/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { useProgress } from '@revenuewell/logic-progress';
import { useOidc } from '@revenuewell/logic-oidc';

export const PrivateRoute = ({ component, ...rest }: any) => {
    const userFriendlyDelay = 400;
    const { showAppSpinner } = useProgress();
    const { isAuthenticated, signinRedirect } = useOidc();
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
 
    useEffect(() => {
        if(showSpinner) {
            showAppSpinner('Authentication is required');
        }
    }, [showSpinner])

    const renderComponent = (props: any) => {
        if (isAuthenticated()) {
            return React.createElement(component, props);
        } else {
            setShowSpinner(true);
            setTimeout(() => signinRedirect(), userFriendlyDelay);
        }
    };

    return <Route {...rest} render={renderComponent} />;
};